import Skeleton from 'react-loading-skeleton';


function SkeletonLoader() {
    return (
        <div style={{ padding: '20px' }}>
            <div  style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                <Skeleton height={40} width={"100%"} style={{ marginBottom: '20px' }} />
                <Skeleton height={40} width={"100%"} style={{ marginBottom: '20px' }} />
            </div>

            <div style={{ marginBottom: '10px' }}>
                <Skeleton height={40} width="100%" />
            </div>

            <div style={{ marginBottom: '20px' }}>
                <Skeleton height={50} width="100%" />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
                {Array(15).fill().map((_, index) => (
                    <Skeleton key={index} height={100} />
                ))}
            </div>
        </div>
    );
}

export default SkeletonLoader;